export default "<input #input pInputText pKeyFilter=\"int\" [(ngModel)]=\"value\" style=\"width: 100%; height: 100%\" placeholder=\"Enter\">";